import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getMySanctions } from "../api/sanctions";

/**
 * Глобальный контекст активных санкций юзера для rublox.pro.
 * Дёргает /api-storys/api/v1/storys/me/sanctions один раз при монтировании.
 * Все компоненты (комменты, чат, публикация) проверяют isMuted / isCantPublish
 * вместо собственных запросов.
 */
const SanctionsContext = createContext({
  sanctions: [], isMuted: false, isCantPublish: false,
  muteInfo: null, cantPublishInfo: null, loading: true, reload: () => {},
});

export function SanctionsProvider({ children }) {
  const [sanctions, setSanctions] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!localStorage.getItem("rublox_token")) {
      setSanctions([]);
      setLoading(false);
      return;
    }
    try {
      const r = await getMySanctions();
      setSanctions(Array.isArray(r?.sanctions) ? r.sanctions : []);
    } catch {
      setSanctions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "rublox_token") reload();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [reload]);

  const muteInfo = sanctions.find((s) =>
    ["user_timed_ban", "chat_ban", "comment_ban"].includes(s.type)
  ) || null;
  const isMuted = !!muteInfo;

  const cantPublishInfo = sanctions.find((s) =>
    ["user_timed_ban", "publish_ban"].includes(s.type)
  ) || null;
  const isCantPublish = !!cantPublishInfo;

  return (
    <SanctionsContext.Provider value={{
      sanctions, isMuted, isCantPublish,
      muteInfo, cantPublishInfo, loading, reload,
    }}>
      {children}
    </SanctionsContext.Provider>
  );
}

export function useSanctions() {
  return useContext(SanctionsContext);
}
